/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionUpcomingPaymentAdminData
 */
export interface SubscriptionUpcomingPaymentAdminData {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    subscriptionId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    projectId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    projectName?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    packageCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    billingCycle?: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    currency?: string;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    dueAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    status?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    isTrial?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    netAmount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    vatAmount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    roundingAmount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    totalAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    currencyCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    vatPercentage?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    reverseCharge?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUpcomingPaymentAdminData
     */
    financialDataStatus?: string;
}

/**
 * Check if a given object implements the SubscriptionUpcomingPaymentAdminData interface.
 */
export function instanceOfSubscriptionUpcomingPaymentAdminData(value: object): value is SubscriptionUpcomingPaymentAdminData {
    return true;
}

export function SubscriptionUpcomingPaymentAdminDataFromJSON(json: any): SubscriptionUpcomingPaymentAdminData {
    return SubscriptionUpcomingPaymentAdminDataFromJSONTyped(json, false);
}

export function SubscriptionUpcomingPaymentAdminDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionUpcomingPaymentAdminData {
    if (json == null) {
        return json;
    }
    return {
        
        'subscriptionId': json['subscriptionId'] == null ? undefined : json['subscriptionId'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'projectName': json['projectName'] == null ? undefined : json['projectName'],
        'packageCode': json['packageCode'] == null ? undefined : json['packageCode'],
        'billingCycle': json['billingCycle'] == null ? undefined : json['billingCycle'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'dueAt': json['dueAt'] == null ? undefined : (new Date(json['dueAt'])),
        'status': json['status'] == null ? undefined : json['status'],
        'isTrial': json['isTrial'] == null ? undefined : json['isTrial'],
        'netAmount': json['netAmount'] === undefined ? undefined : json['netAmount'] === null ? null : json['netAmount'],
        'vatAmount': json['vatAmount'] === undefined ? undefined : json['vatAmount'] === null ? null : json['vatAmount'],
        'roundingAmount': json['roundingAmount'] === undefined ? undefined : json['roundingAmount'] === null ? null : json['roundingAmount'],
        'totalAmount': json['totalAmount'] === undefined ? undefined : json['totalAmount'] === null ? null : json['totalAmount'],
        'currencyCode': json['currencyCode'] === undefined ? undefined : json['currencyCode'] === null ? null : json['currencyCode'],
        'vatPercentage': json['vatPercentage'] === undefined ? undefined : json['vatPercentage'] === null ? null : json['vatPercentage'],
        'reverseCharge': json['reverseCharge'] === undefined ? undefined : json['reverseCharge'] === null ? null : json['reverseCharge'],
        'financialDataStatus': json['financialDataStatus'] == null ? undefined : json['financialDataStatus'],
    };
}

export function SubscriptionUpcomingPaymentAdminDataToJSON(json: any): SubscriptionUpcomingPaymentAdminData {
    return SubscriptionUpcomingPaymentAdminDataToJSONTyped(json, false);
}

export function SubscriptionUpcomingPaymentAdminDataToJSONTyped(value?: SubscriptionUpcomingPaymentAdminData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subscriptionId': value['subscriptionId'],
        'projectId': value['projectId'],
        'projectName': value['projectName'],
        'packageCode': value['packageCode'],
        'billingCycle': value['billingCycle'],
        'amount': value['amount'],
        'currency': value['currency'],
        'dueAt': value['dueAt'] == null ? value['dueAt'] : value['dueAt'].toISOString(),
        'status': value['status'],
        'isTrial': value['isTrial'],
        'netAmount': value['netAmount'],
        'vatAmount': value['vatAmount'],
        'roundingAmount': value['roundingAmount'],
        'totalAmount': value['totalAmount'],
        'currencyCode': value['currencyCode'],
        'vatPercentage': value['vatPercentage'],
        'reverseCharge': value['reverseCharge'],
        'financialDataStatus': value['financialDataStatus'],
    };
}

